export default {
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(), //페이지 정보

	carSaleList: [],
	flclSpcList: [], //검색 연료전지사양 셀렉트박스
	carScnList: [], //검색 차량구분 셀렉트박스
	companySaleList: [], //검색 판매일 셀렉스박스
	saleRegnList: [], //검색 판매지역 셀렉트박스
	customPrCorList: [], //검색 생산법인 커스텀 셀렉트박스
	pacScnList: [], //검색 승상구분 셀렉트박스
	plntCdList: [], //검색 생산공장 셀렉트박스
	carTypeNmList: [],

	prcsStepList: [], //조회조건 처리단계
	gridPrcStepList: [], //그리드안에 사용여부
	excelDownLoadList: [] //엑셀다운로드시 해더저장
};
function SEARCH_PARAMS() {
	return {
		pmcId: '', //제품ID
		pmcNo: '', //제품NO
		flclSpc: '', //연료전지사양
		saleRegn: '', //판매지역
		carVin: '', //차량 VIN
		carScn: '', //차량구분
		srchMm03: '', //날짜구분
		pwrType: '', //동력유형
		pacScn: '', //승상구분
		carTypeNm: '',
		strtMm01: '', //strtMm01
		endMm01: '', //endMm01
		idxScn:'',
		licensePlate: ''
	};
}
function PAGING_INFO() {
	return {
		currentPage: 1,
		pageUnit: 30,
		totalSize: 0
	};
}
export { SEARCH_PARAMS, PAGING_INFO };
